export const DEFAULT_STAFF_ADMIN_PATH = '/admin/dashboard';

const INTERNAL_ORIGIN = 'https://admin.visinvoke.invalid';
const AUTH_FLOW_PATHS = new Set([
  '/admin',
  '/admin/login',
  '/admin/mfa-setup',
  '/admin/mfa-verify',
  '/admin/staff-verify',
  '/admin/select-role',
  '/admin/reset-password',
  '/admin/mfa-recovery',
]);

export function normalizeStaffAdminReturnPath(value, fallback = DEFAULT_STAFF_ADMIN_PATH) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return fallback;
  if (value.includes('\\') || [...value].some((character) => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127;
  })) return fallback;

  try {
    const parsed = new URL(value, INTERNAL_ORIGIN);
    if (parsed.origin !== INTERNAL_ORIGIN) return fallback;
    if (!(parsed.pathname === '/admin' || parsed.pathname.startsWith('/admin/'))) return fallback;
    if (AUTH_FLOW_PATHS.has(parsed.pathname) || parsed.pathname.startsWith('/admin/invite/')) return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
}

export function currentStaffAdminPath(location) {
  if (!location) return DEFAULT_STAFF_ADMIN_PATH;
  return normalizeStaffAdminReturnPath(
    `${location.pathname || ''}${location.search || ''}${location.hash || ''}`,
  );
}

export function requestedStaffAdminPath(location) {
  const state = location && location.state;
  return normalizeStaffAdminReturnPath(state && (state.returnTo || state.from));
}

export function staffAdminReturnState(returnTo) {
  return { returnTo: normalizeStaffAdminReturnPath(returnTo) };
}